import { useState, useEffect } from 'react'
import { Outlet } from "react-router-dom";
import { ToggleMenuBtn } from "./Navigation";
import NavigationMenu from "./Navigation"
import './layout.css';

const PageHeader = ({ children }) => <header id="page-layout-header"> {children} </header>

const PageMain = () => <main id="page-layout-main"> <Outlet /> </main>

const PageFooter = ({ children }) => {
    return (
        <footer id="page-layout-footer">
            {children}
            <p className="page-layout-footer"> {'\u00A9'} 2025 Olive Tree Solidarity Coalition</p>
        </footer>
    )
}



const Layout = () => {

    const [lastScrollY, setLastScrollY] = useState(0);
    const [showHeader, setShowHeader] = useState(true);
    const [sideNavHidden, setSideNavHidden] = useState(true);

    const controlNavbar = () => {

        if (typeof window !== 'undefined') {
            if (sideNavHidden == true) {
                const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
                // Check if the sum of current scroll position and visible height is approximately equal to the total scrollable height
                // A small tolerance (e.g., 1 pixel) is often used to account for potential rounding differences
                const isAtBottom = (scrollTop + clientHeight >= scrollHeight - 1)
                if (window.scrollY > lastScrollY && window.scrollY > 100) { // Adjust 100 as needed
                    // if scroll down and past a certain threshold, hide the navbar
                    if (sideNavHidden == true) {
                        setShowHeader(false);
                    }
                } else {
                    if (!isAtBottom) {
                        setShowHeader(true);
                    }
                }
            }

            setLastScrollY(window.scrollY);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', controlNavbar);
            // cleanup function to remove the event listener
            return () => {
                window.removeEventListener('scroll', controlNavbar);
            };
        }
    }, [lastScrollY, sideNavHidden]); // Re-run effect only when lastScrollY changes


    const handleNavToggleClick = () => setSideNavHidden(!sideNavHidden)

    const handleNavInput = () => setSideNavHidden(!sideNavHidden)

    return (
        <div id="page-layout">
            <PageHeader>
                <ToggleMenuBtn handleClick={handleNavToggleClick} showHeader={showHeader} />
                <NavigationMenu
                    handleNavInput={handleNavInput}
                    navLayout={`${sideNavHidden ? 'hide-sidenav' : 'show-sidenav'}`} />
            </PageHeader>
            <PageMain />
            <PageFooter />
        </div>
    )
};

export { PageFooter, PageHeader, PageMain };
export default Layout;



